import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import axios from "axios";
import { useHistory } from "react-router-dom";

function CaseManagement() {
    const navigate = useHistory();
    const [PortalList, setPortalList] = useState([]); // List of all portals
    const [SourcePortalCases, setSourcePortalCases] = useState([]); // List of all cases present in selected source portal
    const [TargetPortalCases, setTargetPortalCases] = useState([]); // List of all cases to be transferred in selected target portal
    const [SourcePortalId, setSourcePortalId] = useState(""); // ID of selected source portal
    const [TargetPortalId, setTargetPortalId] = useState(""); // ID of selected target portal
    const [SelectedPortalCases, setSelectedPortalCases] = useState([]); // Temporary list to store selected / checked cases(from source portal)
    const [sourceSearchQuery, setSourceSearchQuery] = useState(""); // Search filter state (for source portal)
    const [targetSearchQuery, setTargetSearchQuery] = useState(""); // Search filter state (for target portal)
    const [casesLimit, setCasesLimit] = useState(""); // Stores the total case limit (set to the selected target portal)
    const [casesRemaining, setCasesRemaining] = useState(""); // Stores the remaining case limit (set to the selected target portal)
    const [isSubmitting, setIsSubmitting] = useState(false);

    useEffect(() => {
        // Load all portals
        LoadPortals();
    }, [],);

    // Fetch List of all portals
    const LoadPortals = () => {
        axios.get(`${process.env.REACT_APP_API_URL}/GetPortalList`).then((res) => {
            setPortalList(res.data);
        });
    };

    // Handle selecting/deselecting of "Source Portal"
    const onSourcePortalSelected = (event) => {
        setSourceSearchQuery("");
        setTargetSearchQuery("");
        setSelectedPortalCases([]);
        setTargetPortalCases([]);
        setSourcePortalCases([]);
        setSourcePortalId("");

        if (!event.target.value)
            return;

        const selectedItem = PortalList.find((portal) => portal.portalId == event.target.value);

        if (TargetPortalId && TargetPortalId === selectedItem.portalId) {
            Swal.fire({
                title: "Alert!",
                text: "Source and target portal can not be same!",
                icon: "warning",
                confirmButtonText: "Ok",
                allowOutsideClick: false,
            });
        }
        setSourcePortalId(selectedItem.portalId);
        axios.get(`${process.env.REACT_APP_API_URL}/GetAllNewCasesByPortal?portalId=` + selectedItem.portalId).then((res) => {
            setSourcePortalCases(res.data);
        });
    }

    // Handle selecting/deselecting of "Target Portal"
    const onTargetPortalSelected = (event) => {
        setTargetSearchQuery("");
        setCasesLimit("");
        setCasesRemaining("");
        // setTargetPortalCases([]);
        // setTargetPortalId("");

        if (!event.target.value)
            return;

        const selectedItem = PortalList.find((portal) => portal.portalId == event.target.value);

        if (SourcePortalId && SourcePortalId === selectedItem.portalId) {
            Swal.fire({
                title: "Alert!",
                text: "Source and target portal can not be same!",
                icon: "warning",
                confirmButtonText: "Ok",
                allowOutsideClick: false,
            });
        }
        setTargetPortalId(selectedItem.portalId);
        const casesRemaining = selectedItem.casesRemaining;
        const casesLimit = selectedItem.casesLimit;
        const totalCasesLimit = selectedItem.totalCasesLimit;
        const limit = totalCasesLimit > 0 ? totalCasesLimit : casesLimit;

        if (limit > 0) {
            setCasesLimit(limit);
            setCasesRemaining(casesRemaining);
        } else {
            setCasesLimit("");
            setCasesRemaining("");
        }

        if (limit > 0 && casesRemaining < 1) {
            Swal.fire({
                title: "Limit!",
                text: "You have reached the maximum number of cases for this portal!",
                icon: "warning",
                confirmButtonText: "Ok",
                allowOutsideClick: false,
            });
        }
    }

    // Handle selecting/deselecting items
    const toggleSelection = (id) => {
        setSelectedPortalCases((prevSelected) =>
            prevSelected.includes(id)
                ? prevSelected.filter((item) => item !== id) // Remove if already selected
                : [...prevSelected, id] // Add if not selected
        );
    };

    // Function to sort items alphabetically
    const sortItems = (list) => {
        return [...list].sort((a, b) => a.caseName.localeCompare(b.caseName));
    };

    // Handle transferring items to the right side
    const transferItems = () => {
        const selectedObjects = SourcePortalCases.filter((item) => SelectedPortalCases.includes(item.caseId));
        setTargetPortalCases(sortItems([...TargetPortalCases, ...selectedObjects]));

        // Remove transferred items from left side
        setSourcePortalCases(sortItems(SourcePortalCases.filter((item) => !SelectedPortalCases.includes(item.caseId))));

        // Clear selection after transfer
        setSelectedPortalCases([]);
    };

    // Remove item from right side and move it back to left
    const removeItem = (id) => {
        const itemToRemove = TargetPortalCases.find((item) => item.caseId === id);
        setSourcePortalCases(sortItems([...SourcePortalCases, itemToRemove])); // Add back to left side
        setTargetPortalCases(sortItems(TargetPortalCases.filter((item) => item.caseId !== id))); // Remove from right side
    };

    // Filter items based on search query
    const filteredItems = sortItems(SourcePortalCases).filter((item) =>
        item.caseName.toLowerCase().includes(sourceSearchQuery.toLowerCase())
    );

    const filteredItemsRight = sortItems(TargetPortalCases).filter((item) =>
        item.caseName.toLowerCase().includes(targetSearchQuery.toLowerCase())
    );

    // Select all visible items
    const selectAll = () => {
        const visibleItemIds = filteredItems.map((item) => item.caseId);
        setSelectedPortalCases(
            SelectedPortalCases.length === visibleItemIds.length ? [] : visibleItemIds
        );
    };

    // Handle submit
    const updatePortalCases = async () => {
        if (!TargetPortalId) {
            Swal.fire({ title: "Alert!", text: "Target Portal is not selected!", icon: "warning" });
            return;
        }
        if (!TargetPortalCases || TargetPortalCases.length <= 0) {
            Swal.fire({ title: "Alert!", text: "Target portal doesn't contain any case.", icon: "warning" });
            return;
        }
        if (SourcePortalId === TargetPortalId) {
            Swal.fire({ title: "Alert!", text: "Source and target portal can not be same!", icon: "warning" });
            return;
        }

        // Get token
        let token = null;
        try {
            const raw = localStorage.getItem("state");
            if (raw) {
                const state = JSON.parse(raw);
                token = state.auth?.token;
            }
        } catch (e) {
            console.error("Token parsing failed", e);
        }
        const authHeaders = token ? { Authorization: `Bearer ${token}` } : {};

        try {
            setIsSubmitting(true);

            // Get last patient ID
            const lastIdRes = await axios.get(
                `${process.env.REACT_APP_API_URL}/GetLastPatientId`,
                { headers: authHeaders }
            );
            let newPatientId = parseInt(lastIdRes.data) + 1;

            // ---- preload target portal's assigned envs & chars ----
            const fdEnv = new FormData();
            fdEnv.append("id", TargetPortalId);
            const fdChar = new FormData();
            fdChar.append("id", TargetPortalId);

            const [envListRes, charListRes] = await Promise.all([
                axios.post(`${process.env.REACT_APP_API_URL}/GetAllEnvironmentByPortalId`, fdEnv, { headers: authHeaders }),
                axios.post(`${process.env.REACT_APP_API_URL}/GetAllCharacterByPortalId`, fdChar, { headers: authHeaders }),
            ]);

            const envIds = new Set((envListRes?.data || []).map(e => e.Id ?? e.Environment_Id ?? e.EnvironmentId));
            const charIds = new Set((charListRes?.data || []).map(c => c.Id ?? c.Character_Id ?? c.CharacterId));

            // ---- process each case ----
            for (const c of TargetPortalCases) {
                if (!c.caseId) {
                    console.error("Missing Id for case:", c);
                    continue;
                }

                // Get patient details
                const formDataGet = new FormData();
                formDataGet.append("id", c.caseId);

                const patientRes = await axios.post(
                    `${process.env.REACT_APP_API_URL}/getNewPatientByid`,
                    formDataGet,
                    { headers: authHeaders }
                );

                const p = patientRes.data?.result;
                console.log(p);
                if (!p) {
                    console.error("Patient not found for ID:", c.caseId);
                    continue;
                }

                // ---- ensure Environment exists on target portal ----
                if (p.Environment_Id && !envIds.has(p.Environment_Id)) {
                    const assignEnvForm = new FormData();
                    assignEnvForm.append("portalId", TargetPortalId);
                    assignEnvForm.append("envId", p.Environment_Id);

                    const assignEnvRes = await axios.post(
                        `${process.env.REACT_APP_API_URL}/AssignEnvironmentToPortal`,
                        assignEnvForm,
                        { headers: authHeaders }
                    );

                    if (assignEnvRes?.data?.ExpResult) {
                        setIsSubmitting(false);
                        Swal.fire({ title: "Error", text: assignEnvRes.data.ExpResult, icon: "error" });
                        return;
                    }
                    envIds.add(p.Environment_Id);
                }

                // ---- ensure Character exists on target portal ----
                if (p.Character_Id && !charIds.has(p.Character_Id)) {
                    const assignCharForm = new FormData();
                    assignCharForm.append("portalId", TargetPortalId);
                    assignCharForm.append("charId", p.Character_Id);

                    const assignCharRes = await axios.post(
                        `${process.env.REACT_APP_API_URL}/AssignCharacterToPortal`,
                        assignCharForm,
                        { headers: authHeaders }
                    );

                    if (assignCharRes?.data?.ExpResult) {
                        setIsSubmitting(false);
                        Swal.fire({ title: "Error", text: assignCharRes.data.ExpResult, icon: "error" });
                        return;
                    }
                    charIds.add(p.Character_Id);
                }

                // ---- build AddPatient payload ----
                const addPayload = {
                    Portal_Id: TargetPortalId,
                    Environment_Id: p.Environment_Id,
                    Character_Id: p.Character_Id,
                    Case_Name: p.Case_Name,
                    Patient_Name: p.Patient_Name,
                    DOB: p.DOB,
                    Patient_Gender: p.Patient_Gender,
                    Character_Role: p.Character_Role,
                    User_Role: p.User_Role,
                    Address: p.Address,
                    Place: p.Place,
                    Personal_Life: p.Personal_Life,
                    Patient_Id: newPatientId.toString(),
                    Presenting_Problem: p.Presenting_Problem,
                    About_The_Case: p.About_The_Case,
                    Skill1: p.Skill1,
                    SkillDesc1: p.SkillDesc1,
                    Skill2: p.Skill2,
                    SkillDesc2: p.SkillDesc2,
                    Skill3: p.Skill3,
                    SkillDesc3: p.SkillDesc3,
                    Skill4: p.Skill4,
                    SkillDesc4: p.SkillDesc4,
                    Skill5: p.Skill5,
                    SkillDesc5: p.SkillDesc5,
                    Skill6: p.Skill6,
                    SkillDesc6: p.SkillDesc6,
                    Voice_Id: p.Voice_Id
                };

                const formDataAdd = new FormData();
                console.log(addPayload);
                formDataAdd.append("data", JSON.stringify(addPayload));

                // AddPatient
                const addRes = await axios.post(
                    `${process.env.REACT_APP_API_URL}/AddPatient`,
                    formDataAdd,
                    { headers: { "Content-Type": "multipart/form-data", ...authHeaders } }
                );

                // Evaluate response
                if (addRes.data?.ExpResult) {
                    setIsSubmitting(false);
                    Swal.fire({ title: "Error", text: addRes.data.ExpResult, icon: "error" });
                    return;
                }
                if (addRes.data?.SuccessResult) {
                    console.log("Case added successfully:", addRes.data.SuccessResult);
                } else {
                    setIsSubmitting(false);
                    Swal.fire({ title: "Error", text: "Unexpected response from server.", icon: "error" });
                    return;
                }

                newPatientId++;
            }

            setIsSubmitting(false);
            Swal.fire({ title: "Success", text: "All cases added successfully.", icon: "success" })
                .then(() => window.location.reload());

        } catch (err) {
            setIsSubmitting(false);
            console.error(err);
            Swal.fire({ title: "Error", text: "An error occurred: " + err.message, icon: "error" });
        }
    };

    // Click Listener on Back  Button
    const BackFunc = () => {
        navigate.push("/index");
    };

    return (
        <>
            <div className="page-content-wrapper">
                <div className="page-content" style={{ minHeight: "10vh" }}>
                    <div className="page-bar">
                        <div className="page-title-breadcrumb">
                            <div className=" pull-left">
                                <div className="page-title my-0">Case Management</div>
                            </div>
                        </div>
                        <div className="page-title-breadcrumb">
                            <div className=" pull-right">
                                <button
                                    type="submit"
                                    className="btn d-inline-block"
                                    style={{
                                        backgroundColor: "#1e2b38",
                                        color: "#FFF",
                                        border: "1px solid #1e2b38"
                                    }}
                                    onClick={BackFunc}
                                >
                                    {" "}
                                    <i className="fa fa-arrow-left" aria-hidden="true"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="row">
                                <div className="col-md-12">
                                    {/***** Card Starts /*****/}
                                    <div className="card">
                                        {/***** Card Header Starts /*****/}
                                        {/*<div className="card-head">*/}
                                        {/*     <header>Transfer Case(s)</header>*/}
                                        {/*</div>*/}
                                        {/***** Card Header ENDS /*****/}

                                        {/***** Card Body Starts /*****/}
                                        <div className="card-body ">
                                            <div className="container-fluid p-0">
                                                <div className="row h-100">
                                                    {/*Source Portal Section*/}
                                                    <div className="col-md-5 d-flex p-0 card"
                                                        style={{ boxShadow: "none" }}>
                                                        <div className="card-head">
                                                            <header>
                                                                <select
                                                                    className="form-control select2"
                                                                    onChange={onSourcePortalSelected}
                                                                >
                                                                    <option value="">-- Source Portal --</option>
                                                                    {PortalList.map((result) => {
                                                                        return (
                                                                            <option value={result.portalId}
                                                                                key={result.portalId}>
                                                                                {result.portalName}
                                                                            </option>
                                                                        );
                                                                    })}
                                                                </select>

                                                            </header>
                                                        </div>
                                                        <div className="card-body"
                                                            style={{ minHeight: "60vh", overflowY: "auto" }}>

                                                            {/* Search Input */}
                                                            {SourcePortalCases.length > 0 &&
                                                                <input
                                                                    type="text"
                                                                    className="form-control mb-3"
                                                                    placeholder="Search cases..."
                                                                    value={sourceSearchQuery}
                                                                    onChange={(e) => setSourceSearchQuery(e.target.value)}
                                                                />
                                                            }
                                                            {/* Filtered List */}
                                                            {SourcePortalCases.length > 0 &&
                                                                <ul className="list-group w-100">
                                                                    {filteredItems.length > 0 ? (
                                                                        filteredItems.map((item) => (
                                                                            <li
                                                                                key={item.caseId}
                                                                                className="list-group-item d-flex align-items-center justify-content-between"
                                                                                onClick={() => toggleSelection(item.caseId)}
                                                                                style={{ cursor: "pointer" }}
                                                                            >
                                                                                <div
                                                                                    className="d-flex align-items-center">
                                                                                    <input
                                                                                        type="checkbox"
                                                                                        className="form-check-input me-2"
                                                                                        checked={SelectedPortalCases.includes(item.caseId)}
                                                                                        onClick={(e) => e.stopPropagation()} // Prevents double toggle
                                                                                        onChange={() => toggleSelection(item.caseId)}
                                                                                    />
                                                                                    <span>{item.caseName}</span>
                                                                                </div>
                                                                                <span>{item.patient_Id}</span>
                                                                            </li>
                                                                        ))
                                                                    ) : (
                                                                        <li className="list-group-item text-dark">No
                                                                            items found</li>
                                                                    )}
                                                                </ul>
                                                            }
                                                        </div>
                                                    </div>

                                                    {/*Center Buttons*/}
                                                    <div
                                                        className="col-md-1 justify-content-center d-flex">
                                                        <div style={{ textAlign: "center", marginTop: "230px" }}>
                                                            {/* Select All Button */}
                                                            <button className="btn btn-light my-2" onClick={selectAll}
                                                                disabled={filteredItems.length === 0}>
                                                                {SelectedPortalCases.length === filteredItems.length ? "Deselect All" : "Select All"}
                                                            </button>
                                                            <button className="btn my-2"
                                                                disabled={SelectedPortalCases.length === 0}
                                                                style={{
                                                                    backgroundColor: "#1e2b38",
                                                                    color: "#FFF",
                                                                    border: "1px solid #1e2b38",
                                                                    paddingLeft: "30px",
                                                                    paddingRight: "30px",
                                                                    textAlign: "center",
                                                                    textDecoration: "none",
                                                                    fontSize: "15px"
                                                                }}
                                                                onClick={transferItems}>&gt;&gt;
                                                            </button>

                                                            {!isSubmitting &&
                                                                <button className="btn my-2"
                                                                    style={{
                                                                        backgroundColor: "#1e2b38",
                                                                        color: "#FFF",
                                                                        border: "1px solid #1e2b38"
                                                                    }}
                                                                    onClick={updatePortalCases}>Submit</button>
                                                            }

                                                            {isSubmitting &&
                                                                <button className="btn my-2"
                                                                    style={{
                                                                        backgroundColor: "#1e2b38",
                                                                        color: "#FFF",
                                                                        border: "1px solid #1e2b38"
                                                                    }}
                                                                    onClick={updatePortalCases} disabled>

                                                                    <span className="spinner-grow spinner-grow-sm me-2"
                                                                        aria-hidden="true"></span>
                                                                    <span role="status">Submitting...</span>
                                                                </button>
                                                            }
                                                        </div>
                                                    </div>

                                                    {/*Target Portal Section*/}
                                                    <div className="col-md-6 d-flex p-0 card"
                                                        style={{ boxShadow: "none" }}>
                                                        <div className="card-head">
                                                            <header>
                                                                <select
                                                                    style={{ marginBottom: "10px" }}
                                                                    className="form-control select2"
                                                                    onChange={onTargetPortalSelected}
                                                                >
                                                                    <option value="">-- Target Portal --</option>
                                                                    {PortalList.map((result) => {
                                                                        return (
                                                                            <option value={result.portalId}
                                                                                key={result.portalId}>
                                                                                {result.portalName}
                                                                            </option>
                                                                        );
                                                                    })}
                                                                </select>
                                                                <span id="txtCasesRemaining"
                                                                    style={{
                                                                        color: "#1e2e38",
                                                                        fontWeight: "600",
                                                                        paddingLeft: "5px"
                                                                    }}>
                                                                    {casesLimit && `Cases Remaining : ${casesRemaining}/${casesLimit}`}
                                                                </span>
                                                            </header>
                                                        </div>
                                                        <div className="card-body">
                                                            {/* Show search only when there are transferred items */}
                                                            {TargetPortalCases.length > 0 && (
                                                                <input
                                                                    type="text"
                                                                    className="form-control mb-3"
                                                                    placeholder="Search cases..."
                                                                    value={targetSearchQuery}
                                                                    onChange={(e) => setTargetSearchQuery(e.target.value)}
                                                                />
                                                            )}

                                                            {TargetPortalCases.length > 0 ? (
                                                                <ul className="list-group w-100">
                                                                    {filteredItemsRight.length > 0 ? (
                                                                        filteredItemsRight.map((item) => (
                                                                            <li key={item.caseId}
                                                                                className="list-group-item d-flex justify-content-between align-items-center text-dark">
                                                                                <div
                                                                                    className="d-flex align-items-center">
                                                                                    <span>{item.caseId}</span>
                                                                                </div>
                                                                                <span>{item.caseName}</span>
                                                                                <button
                                                                                    className="btn btn-danger btn-sm"
                                                                                    onClick={() => removeItem(item.caseId)}>✖
                                                                                </button>
                                                                            </li>
                                                                        ))
                                                                    ) : (
                                                                        <li className="list-group-item text-dark">No
                                                                            items found</li>
                                                                    )}
                                                                </ul>
                                                            ) : null}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {/***** Card Body ENDS /*****/}
                                    </div>
                                    {/***** Card ENDS /*****/}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default CaseManagement;
